module.exports = __webpack_public_path__ + "img/avatar6.f675fdbf.png";